import React, { useEffect, useState, Suspense } from "react";
import Unauthorized from "./layouts/unauthorized.jsx";
import Authorized from "./layouts/authorized.jsx";
import Entity from "../app/datasource/Entity";
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from "react-router-dom";

import UniqTheme from "./config/theme";
import { ThemeProvider } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import CircularProgress from "@material-ui/core/CircularProgress";

import HotelsContainer from "./containers/HotelsContainer.jsx";
import axios from "axios";

const UsersContainer = React.lazy(
    () => import("./containers/UsersContainer.jsx"),
);

const ConfigurationsContainer = React.lazy(
    () => import("./containers/ConfigurationsContainer.jsx"),
);

const InterfaceTypesContainer = React.lazy(
    () => import("./containers/InterfaceTypesContainer.jsx"),
);

const CompaniesContainer = React.lazy(
    () => import("./containers/CompaniesContainer.jsx"),
);

const PlacesSaleContainer = React.lazy(
    () => import("./containers/PlacesSaleContainer.jsx"),
);

const AccessLogsContainer = React.lazy(
    () => import("./containers/AccessLogsContainer.jsx"),
);

const InterfacesContainer = React.lazy(
    () => import("./containers/InterfacesContainer.jsx"),
);

const ReportsContainer = React.lazy(
    () => import("./containers/ReportsContainer.jsx"),
);

const PaymentMethodsContainer = React.lazy(
    () => import("./containers/PaymentMethodsContainer.jsx"),
);

const BOUNDED_URLS_LIST = [
    "/operators",
    "/room_types",
    "/room_quotas",
    "/services",
    "/service_categories",
    "/room_feature_categories",
    "/room_features",
    "/rates",
    "/room_rates",
    "/price_periods",
    "/vector_prices",
    "/reservations",
    "/reservations_asu",
    "/banArrivals",
    "/period_residence",
    "/price_explanation",
    "/purchased_services",
    "/promo",
    "/official",
    "/subscriptions",
    "/market_groups",
    "/market_codes",
    "/message_logs",
    "/cancellation_policy",
    "/refund",
    "/access_logs",
];

const ManagerApp = () => {
    const [user, setUser] = useState(null);
    const [error, setError] = useState(null);
    const [hotel, setHotel] = useState(null);
    const [directLink, setDirectLink] = useState(false);
    const [allHotels, setAllHotels] = useState(user?.hotels ?? null);
    const [hotelChanged, setHotelChanged] = useState(false);
    const completeUrl = window.location.href;
    const thisUser = new Entity("users");
    let lastItem;

    const [openLeftMenu, setOpenLeftMenu] = useState(true);

    // useEffect(() => {
    //     if (user) {
    //         axios.get('/manager/data/hotels')
    //             .then(res => setAllHotels(res.data))
    //     }
    // }, [user])

    useEffect(() => {
        if (user && !hotel && allHotels && allHotels?.length > 0) {
            setHotel(allHotels[0]);
        }
    }, [allHotels]);

    const currentUrl = window.location.href;
    const regex = /\/hotels\/(\d+)\//;
    const match = currentUrl.match(regex);

    let hotelIdUrl = null;
    if (match) {
        hotelIdUrl = match[1];
    }

    useEffect(() => {
        if (user) {
            if (user.type === "operator") {
                thisUser
                    .relations(user.id, "hotels")
                    .getRelated()
                    .then((hotels) => {
                        if (hotels) {
                            setAllHotels(hotels);
                            setHotel(hotels[0]);
                        } else {
                            setError(true);
                        }
                    })
                    .catch((error) => {
                        setError(error);
                    });
            }
        }
    }, [user]);

    const getHotelData = (hotelToPick) => {
        setHotelChanged(true);
        setHotel(hotelToPick);
    };

    if (error) {
        alert("Ошибка загрузки!");
    }

    //проверка hotel_id при открытии по прямой ссылке
    if (
        allHotels &&
        hotelIdUrl &&
        !hotel &&
        (hotelIdUrl > 0 || hotelIdUrl <= 10)
    ) {
        setHotelChanged(true);
        setHotel(allHotels[hotelIdUrl - 1]);
        setDirectLink(true);
    }

    if (!user) {
        return (
            <ThemeProvider theme={UniqTheme}>
                <Unauthorized setUser={setUser} hotelIdUrl={hotelIdUrl} />
            </ThemeProvider>
        );
    }

    const inactiveMenu = hotel || user.type === "admin" ? false : true;
    if (completeUrl.includes("reservations")) {
        const completeUrlArr = completeUrl.split("/");
        lastItem = +completeUrlArr[completeUrlArr?.length - 1];
    }

    if (user.type === "operator" && !hotel) {
        return (
            <Router basename="/manager">
                <ThemeProvider theme={UniqTheme}>
                    <Authorized
                        user={user}
                        inactiveMenu={inactiveMenu}
                        setUser={setUser}
                        openLeftMenu={openLeftMenu}
                        setOpenLeftMenu={setOpenLeftMenu}
                        hotel={hotel}
                        hotelColor={
                            user?.hotelDates?.[+hotelIdUrl - 1]?.color_main
                        }
                        hotelLogo={
                            user?.hotelDates?.[+hotelIdUrl - 1]?.logo_address
                        }
                    >
                        <div>
                            You have no active hotels, please consult to your
                            manager!{" "}
                        </div>
                    </Authorized>
                </ThemeProvider>
            </Router>
        );
    }

    if (hotelIdUrl && !hotel && user?.hotels) {
        const hotelsAll = {};
        user?.hotels?.forEach((h) => {
            h.color_main = user?.hotelDates?.[h.id]?.color_main || h.color_main;
            h.logo_address =
                user?.hotelDates?.[h.id]?.logo_address || h.logo_address;
            hotelsAll[h.id] = h;
        });

        setHotel(hotelsAll[hotelIdUrl]);
    }

    return (
        <Router basename="/manager">
            <ThemeProvider theme={UniqTheme}>
                <CssBaseline />
                {hotelChanged && !directLink ? (
                    <Route
                        render={() => (
                            <Route
                                render={() => (
                                    <Redirect to="/reservations" replace />
                                )}
                            />
                        )}
                    />
                ) : null}
                <Authorized
                    user={user}
                    inactiveMenu={inactiveMenu}
                    setUser={setUser}
                    hotelName={hotel?.name}
                    setHotel={setHotel}
                    openLeftMenu={openLeftMenu}
                    setOpenLeftMenu={setOpenLeftMenu}
                    hotel={hotel}
                    hotelColor={user?.hotelDates?.[+hotelIdUrl - 1]?.color_main}
                    hotelLogo={
                        user?.hotelDates?.[+hotelIdUrl - 1]?.logo_address
                    }
                >
                    <Suspense fallback={<CircularProgress />}>
                        <Switch>
                            <Route
                                path="/companies"
                                component={(props) => (
                                    <CompaniesContainer
                                        {...props}
                                        user={user}
                                        defaultHotels={user?.hotels}
                                    />
                                )}
                            />
                            <Route
                                path="/places_sales"
                                component={(props) => (
                                    <PlacesSaleContainer {...props} />
                                )}
                            />
                            <Route
                                path="/hotels"
                                component={(props) => (
                                    <HotelsContainer
                                        hotelName={hotel?.name}
                                        {...props}
                                        user={user}
                                        setHotel={getHotelData}
                                        setHotelChanged={setHotelChanged}
                                        hotelId={hotel?.id}
                                        openLeftMenu={openLeftMenu}
                                        setDirectLink={setDirectLink}
                                    />
                                )}
                            />
                            <Route
                                path="/users"
                                component={(props) => (
                                    <UsersContainer {...props} user={user} />
                                )}
                            />
                            <Route
                                path="/access_logs"
                                component={(props) => (
                                    <AccessLogsContainer
                                        {...props}
                                        user={user}
                                    />
                                )}
                            />
                            <Route
                                path="/configurations"
                                component={(props) => (
                                    <ConfigurationsContainer
                                        {...props}
                                        user={user}
                                    />
                                )}
                            />
                            <Route
                                path="/payment_methods"
                                component={(props) => (
                                    <PaymentMethodsContainer
                                        {...props}
                                        user={user}
                                    />
                                )}
                            />
                            <Route
                                path="/interface_types"
                                component={(props) => (
                                    <InterfaceTypesContainer
                                        {...props}
                                        user={user}
                                    />
                                )}
                            />
                            <Route
                                path="/interfaces"
                                component={(props) => (
                                    <InterfacesContainer
                                        {...props}
                                        user={user}
                                        defaultHotels={user?.hotels}
                                    />
                                )}
                            />
                            <Route
                                path="/reports"
                                component={(props) => (
                                    <ReportsContainer
                                        {...props}
                                        user={user}
                                        hotelId={hotel?.id}
                                    />
                                )}
                            />
                            {BOUNDED_URLS_LIST.map((url) => (
                                <Route
                                    key={`urlItem${url}`}
                                    path={url}
                                    render={(props) => (
                                        <Redirect
                                            to={compileRedirectUrl(hotel, url)}
                                            {...props}
                                        />
                                    )}
                                />
                            ))}
                            {lastItem || directLink ? null : [
                                  "manager",
                                  "manager_export",
                              ].includes(user.type) && !hotelChanged ? (
                                <Route
                                    render={() => (
                                        <Redirect to="/hotels" replace />
                                    )}
                                />
                            ) : hotel ? (
                                <Route
                                    render={() => (
                                        <Redirect to="/reservations" replace />
                                    )}
                                />
                            ) : (
                                <Route
                                    render={() => <Redirect to="/" replace />}
                                />
                            )}
                            <Route
                                render={() => (
                                    <Route
                                        render={() => (
                                            <Redirect to="/hotels" replace />
                                        )}
                                    />
                                )}
                            />
                        </Switch>
                    </Suspense>
                </Authorized>
            </ThemeProvider>
        </Router>
    );
};

export default ManagerApp;

// Helper funcs

/**
 * Compiles redirect string
 * @param {object} hotelItem
 * @param {string} urlStr
 * @returns
 */
const compileRedirectUrl = (hotelItem, urlStr) => {
    if (!hotelItem) return "/hotels";
    if (urlStr === "/operators") return `/hotels/${hotelItem.id}/users`;
    return `/hotels/${hotelItem.id}${urlStr}`;
};
